import { round } from 'lodash'
import AnswerItem from './answer_item'
import UserExam from '../../../client/models/user_exam'

export default class SkillItem {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly note: string
  readonly allotment: number
  readonly level: number
  readonly point: number
  readonly skillId: number
  readonly criteria: string
  readonly createdAt: string
  readonly updatedAt: string
  readonly averageScore: number
  readonly answerItems: AnswerItem[]

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.note = data.note
    this.allotment = data.allotment
    this.level = data.level
    this.point = data.point
    this.skillId = data.skillId
    this.criteria = data.criteria
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.averageScore = data.averageScore

    if (data.answerItems) {
      this.answerItems = data.answerItems.map((element) => new AnswerItem(element))
    }
  }

  getCurrentAverage(userExam: UserExam): number {
    const skillItemAssessments = userExam.assessment.filter(assessment => assessment.skillItemId == this.id)

    if (skillItemAssessments.length == 0) {
      return 0
    }

    let total = 0
    let totalAnswerAlottment = 0
    skillItemAssessments.forEach(assessment => {
      total += (assessment.score || 0)
      totalAnswerAlottment += (assessment.totalAnswerItemsAllotment || 0)
    })

    if (totalAnswerAlottment == 0) {
      return 0
    }
    return round((total / totalAnswerAlottment) * 100, 1)
  }
}
